<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <form class="search-box position-relative">
          <input
            type="text"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Search product"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
        <div class="d-sm-flex align-items-center">
          
          <button
            class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0"
            type="button"
          >
            Export
            <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  #
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Date
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  type
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Formule
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  numéro abonnement
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Nb mois
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Montant Payé
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Etat
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(mag, index) in demandes" :key="index">
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ mag.id }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ (mag.createdAt) ? format_DATE(mag.createdAt) : '' }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ mag.type }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  <span
                    class="badge rounded-pill bg-info"
                  >
                    {{ mag?.formule?.libelle }}
                  </span>
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ mag.numAbonnement }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ mag.nobreMois }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ mag.montantPayer }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  <span
                    class="badge rounded-pill"
                    :class="{
                      'bg-warning text-dark': mag.etat === 'En Attente',
                      'bg-success': mag.etat === 'Traitée',
                      'bg-danger': mag.etat === 'Rejetée'
                    }"
                  >
                  {{ mag.etat }}
                  </span>
                </td>
                <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
              <div class="dropdown disabled">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li v-if="mag.etat == 'En Attente' || mag.etat == 'En attente'">
                      <router-link
                        class="dropdown-item d-flex align-items-center"
                        :to="`/detail/demande/${mag.id}`">
                        Traiter
                      </router-link>
                    </li>
                    <!-- <li v-if="mag.etat == 'En Attente'">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#AddElementModal"
                        @click="modification(mag)"
                      >
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Valider
                      </a>
                    </li>
                    <li v-if="mag.etat == 'En Attente'">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);" @click="suppression(mag.id,demandes,'demande','cette demande')"
                      >
                        <i
                          class="flaticon-delete lh-1 me-8 position-relative top-1" 
                        ></i>
                        Annuler
                      </a> 
                    </li> -->
                  </ul>
              </div>
              </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>

    <ValiderDemande :item="selectedItem"   @close="recharger"/>
  </template>
  
  <script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { paginationFields } from '../Utilities/paginationFields';
import { error, suppression, format_DATE } from '../../utils/utils';
import ApiService from "../../services/ApiService";
import  { Demande }  from '../../models/Demande';
import ValiderDemande from './ValiderDemandeModal.vue';
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import { formatDate } from '@fullcalendar/core';
import router from '@/router';

  export default defineComponent({
    name: "ListeDemande",
    components: {
      ValiderDemande,
      PaginationComponent
    },
    setup: () => {

      const demandes = ref<Array<Demande>>([]);
      const selectedItem = ref(0);
      const magasin = ref<Demande>();
     
      function modification(item) {
        magasin.value = item;
        selectedItem.value = item.id;
      }

      // BEGIN PAGINATE
        const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        const handlePaginate = ({ page_, limit_ }) => {
          try {
            page.value = page_;
            getAll(page_, limit_);
          } catch (error) {
            //
            
          }
        };
        function rechercher(){
          getAll(page.value, limit.value, searchTerm.value );
        }
      // END PAGINATE

      const recharger = () => {
        getAll();
      };

      onMounted(() => {
        getAll();
      })

      function getAll(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`demandes?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          console.log('result', data.data.data);
          demandes.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          console.log("yes",data.data.data);
        })
        .catch(({ response }) => {
          console.log('error',response.data)
          error(response.data)
        });
      } 

      return { 
        getAll,
        suppression,
        modification,
        demandes,
        recharger,
        selectedItem,
        format_DATE,
        page,
        totalPages,
        totalElements,
        limit,
        searchTerm,
        handlePaginate,
        rechercher
      };
    }

  });
  </script>